import { Injectable } from "@angular/core";

export type submenu_key = 'store' | 'store_classification';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
    allSubMenu = {
        store: [
            // { 
            //   label: 'Brand',
            //   icon: '/assets/v3/icon/navigation/store/brand.svg',
            //   parentLink: 'brand',
            //   routerLink: 'brand-setup'
            // },
            // { 
            //   label: 'Legal Entities',
            //   icon: '/assets/v3/icon/navigation/store/legal-entities.svg',
            //   parentLink: 'legal-entities',
            //   routerLink: 'legal-setup'
            // },
            { 
            label: 'Store',
            icon: '/assets/v3/icon/navigation/store/store.svg',
            parentLink: 'store',
            routerLink: 'store-structure'
            }
        ],
        store_classification: [
            { 
                label: 'Group',
                icon: '/assets/v3/icon/navigation/store/store-group.svg',
                parentLink: 'store',
                routerLink: 'store-group'
            },
            { 
                label: 'Country',
                icon: '/assets/v3/icon/navigation/store/store-country.svg',
                parentLink: 'store',
                routerLink: 'store-country'
            },
            { 
                label: 'State',
                icon: '/assets/v3/icon/navigation/store/store-state.svg',
                parentLink: 'store',
                routerLink: 'store-state'
            },
            { 
                label: 'City',
                icon: '/assets/v3/icon/navigation/store/store-city.svg',
                parentLink: 'store',
                routerLink: 'store-city'
            }

        ],
        stock_classification: [
            { 
                label: 'Group',
                icon: '/assets/v3/icon/navigation/stock/stock-group.svg',
                parentLink: 'stock',
                routerLink: 'stock-gd'
            },
            { 
                label: 'Department',
                icon: '/assets/v3/icon/navigation/stock/stock-department.svg',
                parentLink: 'stock',
                routerLink: 'stock-department'
            }
        ],
        user_management: [
            { 
                label: 'Portal',
                icon: '/assets/v3/icon/navigation/user/user-portal.svg',
                parentLink: 'security-level',
                routerLink: 'user'
            },
            { 
                label: 'Employee',
                icon: '/assets/v3/icon/navigation/user/user-employee.svg',
                parentLink: 'security-level',
                routerLink: 'employee-details'
            },
            { 
                label: 'Agent',
                icon: '/assets/v3/icon/navigation/user/user-agent.svg',
                parentLink: 'security-level',
                routerLink: 'agent-list'
            }

        ],
        user_classification: [
            { 
                label: 'Employee Group',
                icon: '/assets/v3/icon/navigation/user/user-group.svg',
                parentLink: 'security-level',
                routerLink: 'employee-group'
            },
            { 
                label: 'Employee Class',
                icon: '/assets/v3/icon/navigation/user/user-class.svg',
                parentLink: 'security-level',
                routerLink: 'employee-class'
            },
            { 
                label: 'Agent Group',
                icon: '/assets/v3/icon/navigation/user/agent-group.svg',
                parentLink: 'security-level',
                routerLink: 'agent-group'
            },

        ],
        customer_classification: [
            { 
                label: 'Customer Group',
                icon: '/assets/v3/icon/navigation/customer/customer-group.svg',
                parentLink: 'customer',
                routerLink: 'cust-group'
            },
            { 
                label: 'Customer Class',
                icon: '/assets/v3/icon/navigation/customer/customer-class.svg',
                parentLink: 'customer',
                routerLink: 'class'
            },

        ],
        inventory_stock_take:[
            { 
                label: 'Preparation',
                icon: '',
                parentLink: 'inventory',
                routerLink: 'stocktake-preparation'
            },
            { 
                label: 'Entry',
                icon: '',
                parentLink: 'inventory',
                routerLink: 'stocktake-entry'
            }

        ],
        supplier_classification: [
            { 
                label: 'Supplier Group',
                icon: '/assets/v3/icon/navigation/supplier/supplier-group.svg',
                parentLink: 'supplier',
                routerLink: 'supplier-group'
            },
            { 
                label: 'Supplier Class',
                icon: '/assets/v3/icon/navigation/supplier/supplier-class.svg',
                parentLink: 'supplier',
                routerLink: 'supplier-class'
            },

        ],
        inventory_settings: [
            { 
                label: 'Approvals Settings',
                icon: '/assets/v3/icon/navigation/settings/inventory-approve.svg',
                parentLink: 'settings',
                routerLink: 'inventory-approval-settings'
            },
            // { 
            //     label: 'UOM Settings',
            //     icon: '/assets/v3/icon/navigation/settings/inventory-uom.svg',
            //     parentLink: 'settings',
            //     routerLink: 'inventory-uom-settings'
            // },

        ],
        supplier_settings: [
            { 
                label: 'Approval Settings',
                icon: '/assets/v3/icon/navigation/settings/supplier-approve.svg',
                parentLink: 'settings',
                routerLink: 'supplier-approval-settings'
            },
        ],
        preferences_settings: [
            { 
                label: 'Price Shift',
                icon: '/assets/v3/icon/navigation/settings/preferences-profit.svg',
                parentLink: 'settings',
                routerLink: 'price-shift'
            },
            { 
                label: 'Price Level',
                icon: '/assets/v3/icon/navigation/settings/preferences-totalsales.svg',
                parentLink: 'settings',
                routerLink: 'price-level'
            },
        ],
        kitchen_settings: [
            { 
                label: 'Queue',
                icon: '/assets/v3/icon/navigation/settings/kitchen-queue.svg',
                parentLink: 'settings',
                routerLink: 'queue'
            },
            { 
                label: 'Spooler & Printer',
                icon: '/assets/v3/icon/navigation/settings/kitchen-spooler.svg',
                parentLink: 'settings',
                routerLink: 'spooler-printer'
            },
        ],
        misc_settings: [
            { 
                label: 'Reason',
                icon: '/assets/v3/icon/navigation/settings/misc-reason.svg',
                parentLink: 'settings',
                routerLink: 'reason'
            },
            { 
                label: 'Currency',
                icon: '/assets/v3/icon/navigation/settings/misc-currency.svg',
                parentLink: 'settings',
                routerLink: 'currency'
            },
        ],
        emenu_settings: [
            { 
                label: 'Menu',
                icon: '/assets/v3/icon/navigation/settings/emenu-menu.svg',
                parentLink: 'settings',
                routerLink: 'emenu-menu'
            },
            { 
                label: 'Settings',
                icon: '/assets/v3/icon/navigation/settings/emenu-configure.svg',
                parentLink: 'settings',
                routerLink: 'emenu-settings'
            },
            // { 
            //     label: 'Promotion',
            //     icon: '/assets/v3/icon/navigation/settings/emenu-promotion.svg',
            //     parentLink: 'settings',
            //     routerLink: 'emenu-promotion'
            // },
            { 
                label: 'Activity Log',
                icon: '/assets/v3/icon/navigation/settings/emenu-log.svg',
                parentLink: 'settings',
                routerLink: 'emenu-log'
            },
        ],
    }

    getMenu(key: submenu_key){
         return this.allSubMenu[key];
    }
}